import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const PartnerMaster = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Partner Master"))
  }, [])
  const [searchTerm, setSearchTerm] = useState("");
  const [partnerMasterData, setPartnerMasterData] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = {
    // ID: { text: "ID", align: "start", visible: false },
    Name: { text: "Name", align: "left", visible: true },
    City: { text: "City", align: "start", visible: true },
    PrimarySkill: { text: "Primary Skills", align: "start", visible: true },
    Technology_Partner: { text: "Technology Partner", align: "start", visible: true },
    Rom_name: { text: "RMG POC", align: "start", visible: true },
    Address: { text: "Address", align: "left", visible: false },
    Zip_code: { text: "Zip Code", align: "center", visible: false },
    Contact: { text: "Contact No.", align: "end", visible: false },
    Email: { text: "Email ID.", align: "left", visible: false },
    Gst_vat: { text: `GST/VAT #`, align: "center", visible: false },
    Vsa_Start_Date: { text: "Start Date", align: "center", whiteSpace: "nowrap", visible: false },
    Vsa_End_Date: { text: " End Date", align: "center", visible: false },
    Country: { text: "Country", align: "start", visible: false },
    State: { text: "State", align: "start", visible: false },
  };

  useEffect(() => {
    fetchRomVendor();
  }, []);


  const [apiStatus, setApiStatus] = useState(undefined)

  const fetchRomVendor = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(`${API_URL}Rom-vendor`);
      setApiStatus(response?.status)
      if (response.status === 200) {
        const cleanedData = response?.data?.data?.headers;
        setPartnerMasterData(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partner Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Partner Master:", error);
    }
  };

  const handleEdit = (id) => {
    // navigate(`/partner-master/edit/${id.ID}`);
     const url = `/partner-master/edit/${id.ID}`;
    window.open(url, '_blank'); // Opens in new tab
  };

  const handleAddSubContractor = (id) => {
    // navigate(`/contractors/add/${id.ID}`);
        const url = `/contractors/add/${id.ID}`;
    window.open(url, '_blank'); // Opens in new tab
  };

  const handleAddNewPartner = () => {
    navigate("/partner-master/add");

  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={partnerMasterData}
              columns={columns}
              itemsPerPage={8}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={false}
              isActionRequired={true}
              isSorting={true}
              isAddNewBtnRequired={true}
              showIcon3={false}
              showIcon4={true}
              showIcon5={false}
              handleIcon1={handleEdit}
              handleAddNew={handleAddNewPartner}
              handleIcon4={handleAddSubContractor}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon1Text: " Edit",
                Icon2: <i class="bi bi-trash-fill icons"></i>,
                Icon3: <i class="bi bi-eye-fill icons"></i>,
                Icon4: <i class="bi bi-plus-square icons"></i>,
                Icon4Text: " Add Sub-Contractor",
              }}
            />
          </div>
        </div>

      </div>
    </>
  );
};

export default PartnerMaster;
